import { isObject } from 'radash';
import { CompositionConfig } from '@/App/remotion/MainPlayer/types/CompositionConfig';
import { TrackType } from '@/App/remotion/MainPlayer/types/Track/Type';
import { ImageElement } from '@/App/remotion/MainPlayer/types/Element/ImageElement';
import { VideoElement } from '@/App/remotion/MainPlayer/types/Element/VideoElement';
import { TransitionLifeCycleType } from '@/App/remotion/MainPlayer/types/Animations/Transitions/Transitions.types';

type PlayerConfigType = Pick<
  CompositionConfig,
  'playerConfig' | 'fps' | 'durationInFrames' | 'height' | 'width' | 'version'
>;

type AcceptablePlayerConfigInput = PlayerConfigType | null | undefined;

export const isPlayerConfigValid = (playerConfig: AcceptablePlayerConfigInput): playerConfig is PlayerConfigType => {
  return isObject(playerConfig);
};

export const getPlayerConfigTracks = (playerConfig: AcceptablePlayerConfigInput) => {
  if (isPlayerConfigValid(playerConfig)) {
    return playerConfig.playerConfig.tracks;
  }
  return null;
};

export const getPlayerConfigElementTracks = (playerConfig: AcceptablePlayerConfigInput) => {
  if (isPlayerConfigValid(playerConfig)) {
    return getPlayerConfigTracks(playerConfig)?.filter(track => track.type === TrackType.ELEMENTS) ?? null;
  }
  return null;
};

export const getAllElementTrackItems = (playerConfig: AcceptablePlayerConfigInput) => {
  if (isPlayerConfigValid(playerConfig)) {
    return getPlayerConfigElementTracks(playerConfig)?.flatMap(track => track.elements) ?? null;
  }
  return null;
};

export const getPlayerConfigElementById = (playerConfig: AcceptablePlayerConfigInput, elementId: string) => {
  if (isPlayerConfigValid(playerConfig)) {
    return getAllElementTrackItems(playerConfig)?.find(e => e.id === elementId) ?? null;
  }
  return null;
};

export const getElementTransitionByLifeCycleType = (
  element: ImageElement | VideoElement,
  lifeCycle: TransitionLifeCycleType
) => {
  if (lifeCycle === TransitionLifeCycleType.IN) {
    return element.transitions?.in ?? null;
  }
  return element.transitions?.out ?? null;
};

export const getElementDurationInMs = (element: ImageElement | VideoElement, fps: number) => {
  return Math.floor(((element.toFrame - element.fromFrame) / fps) * 1000);
};
